import React, { Component } from "react";
import "./Highlight.css";
import sendLogError from "../../sendLogError";
import ContextConstructor from "../Context/Context";

export class Highlight extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ad: [],
      hasAd: false,
    };
  }
  async componentDidMount() {
    this.getGlossaryLink();
  }

  render() {
    let content = this.state.hasAd ? (
      <div className="highlight-div">
        <div className="highlight-div-text">PUB</div>
        <img src={this.state.ad.media} width="100%" height="100%" alt="media"></img>
      </div>
    ) : (
      ""
    );
    return <div>{content}</div>;
  }
  async getGlossaryLink() {
    try {
        const { idToken } = this.context;

        const headers = {
            Authorization: `Bearer ${idToken}`
        };

        const res = await fetch(
            `/Wordpress/GetHighlights?page=${this.props.page}`,
            { headers }
        );

        if (!res.ok) {
            this.setState({ hasAd: false });
            return;
        }

        const mediaLink = await res.json();

        this.setState({
            ad: mediaLink,
            hasAd: true
        });

    } catch (error) {
        console.error("Error fetching highlights:", error);

        this.setState({ hasAd: false });

        sendLogError(error.message, "getGlossaryLink");
    }
  }
}

Highlight.contextType = ContextConstructor;
